// @TODO: combine with ../SideDrawerWrapper
/**
 * Ryan O'Dowd
 * 2018-11-05
 * © Copyright 2018 Oakwood Software Consulting, Inc. All Rights Reserved.
 */
import {
  ScrollView,
  TouchableOpacity,
  View,
} from 'react-native';
import BackgroundGradient from '@components/common/BackgroundGradient';
import Badge from '@components/common/Badge';
import Icon from '@react-native-vector-icons/material-design-icons';
import {
  PROFILE_ROUTE,
} from '@utils/store/actions';
import Photo from '@components/Photo';
import React from 'react';
import SectionHeader from '@components/common/SectionList/Header';
import Text from '@components/common/Text';
import getStyles from './styles';
import hooks from '@hooks';

const SideDrawer = (props: SideDrawerProps) => {
  const navigation = hooks.useNavigation();
  const styles = hooks.useStyles(getStyles);

  const options = props.options.filter((option) => !option.hidden).map((option: any) => {
    return (
      <View key={option.key}>
        {option.horizontalRuleBefore && <View style={styles.horizontalRule} />}
        {option.isSectionTitle
          ? <SectionHeader backgroundColor={styles.isDarkMode ? styles.colors.primaryDark : styles.colors.primaryLight}>{option.title}</SectionHeader>
          : (
            <TouchableOpacity
              style={styles.option}
              onPress={option.onPress}
            >
              {option.iconComponent || (
                <View>
                  <Icon style={[styles.icon, option.iconStyles]} name={option.iconName} />
                  <Badge
                    visible={option.hasBadge}
                    size={12}
                    top={-5}
                    right={-5}
                  />
                </View>
              )}
              <View style={styles.optionTextWrapper}>
                <Text
                  style={[styles.optionText, option.textStyles]}
                  numberOfLines={2}// @TODO: this is causing conflict with adjustsFontSizeToFit (if shrunk to be on one line, the texts is not center justified)
                  adjustsFontSizeToFit={true}
                >
                  {option.title}
                </Text>
                {option.metadata}
              </View>
            </TouchableOpacity>
          )
        }
      </View>
    );
  });

  return (
    <View style={styles.menu}>{/* @TODO: on open, there's a bounce effect that shows a white background...either disable bounce or change white to better color */}
      <BackgroundGradient reverse={true} opacity={0.9} darken={true} />
      <View style={styles.profileWrapper}>
        <TouchableOpacity
          style={styles.avatarAndMetadata}
          onPress={() => navigation.navigate(PROFILE_ROUTE)}
        >
          <View style={styles.avatarContainer}>
            <Photo
              style={styles.avatar}
              onPress={() => navigation.navigate(PROFILE_ROUTE)}
              displayName={props.displayName}
              username={props.username}// @TODO: cutoff on android because italicized...
              badgeSize={0}// @TODO: default value instead
            />
            {/* @TODO: adjustsFontSizeToFit doesn't work on android? */}
          </View>
          <View style={styles.nameAndEmailWrapper}>
            <Text
              style={styles.name}
              adjustsFontSizeToFit={true}
              numberOfLines={1}
              minimumFontScale={0.1}
            >
              {props.displayName}
            </Text>
            <Text
              style={styles.username}
              adjustsFontSizeToFit={true}
              numberOfLines={1}
              minimumFontScale={0.1}
            >
              {props.username}
            </Text>
          </View>
        </TouchableOpacity>
      </View>

      <ScrollView style={styles.optionsWrapper}>
        <View style={styles.options}>
          {options}
        </View>
      </ScrollView>
    </View>
  );
};

class SideDrawerProps {
  displayName: string;
  options: {
    key: string;
    title: string | React.ReactNode, // @TODO: more specific?

    onPress?: () => void,
    iconComponent?: React.ReactNode,
    iconName?: string,
    hasBadge?: boolean,
    horizontalRuleBefore?: boolean,
    isSectionTitle?: boolean;
    hidden?: boolean;
  }[];
  username: string;
};

export default SideDrawer;
